import { render, staticRenderFns } from "./FichaDiarioAtendimento.vue?vue&type=template&id=02a4d3da"
import script from "./FichaDiarioAtendimento.vue?vue&type=script&lang=js"
export * from "./FichaDiarioAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports